import React from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  navLink: {
    textDecoration: 'none',
    color: theme.palette.common.black
  }
}));

export default (props) => {
  const classes = useStyles();
  return (
    <NavLink className={classes.navLink} {...props}>
      {props.children}
    </NavLink>
  );
};